export const RX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const RX_ALLOWED_STRING = /[a-zA-ZçÇñÑáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙäëïöüÄËÏÖÜâêîôûÂÊÎÔÛ\s]/;
